import preparedReducer from './reducer';
import {
  requestAdministrators,
  requestAdministrator,
  createAdministrator,
  updateAdministrator,
  updateAdministratorStatus,
  deleteAdministrator,
} from './actions';

export const reducer = preparedReducer;

export const SLICE_NAME = 'administrators';

export const selectors = (state) => state[SLICE_NAME];

export const selectAdministratorByID = (id) => (state) => state[SLICE_NAME].info[id] || {};

export const actions = {
  requestAdministrators,
  requestAdministrator,
  createAdministrator,
  updateAdministrator,
  updateAdministratorStatus,
  deleteAdministrator,
};
